import { validator } from "@/utils/validator";

export const masterDataLanguageTestSchema = validator.object().shape({
  languageTestName: validator.string().emptyToNull().label("試験名（日本語）").required(),
  ckLanguageTestRenewVisaCsvCode: validator.string().emptyToNull().label("期間更新CSVのコード（列CK）").required(),
});
